// Modules
import React, { useState } from "react";
import { navigate } from "gatsby";
import { findMobileSubMenuItems } from "../../../utilities/dataAlgos";

// Components
import AccordionMenu from "./menuToggleComponent";
import Avatar from "../../SVG/web/avatar";

// SVGs
import CaretDown from "../../SVG/mobile/caretDown";
import CaretUp from "../../SVG/mobile/caretUp";
import CaretRight from "../../SVG/mobile/caretRight";
import BackArrow from "../../SVG/mobile/backArrow";
import { groupArrayItems } from "../../../utilities/dataAlgos";
import Close from "../../SVG/mobile/close";
import { SignOut } from "@phosphor-icons/react";

// Layout: Full menu
function FullMenu({
  menuItems,
  onToggle,
  PageLevel = 0,
  setActiveIndex,
  activeIndex,
  setSecondActiveIndex,
  secondActiveIndex,
  setThirdActiveIndex,
  thirdActiveIndex,
  useInitials,
  userProfileImage,
  userIsSigned,
  handleUserLogout,
  userType,
  urlPathName,
  pathSegments,
}) {
  // State

  const [higjhlightedMenu, setHighlightedMenu] = useState(null);
  const [secondLevelMenus, setSecondLevelMenus] = useState([]);

// console.log("Page Level", PageLevel)

  // Functions
  // function handleMainMenuClose(event) {
  //   onToggle(event);
  //   setTimeout(() => {
  //     setSecondLevelMenus([]);
  //   }, 500); // 500 ms delay because that's how long it takes the animation to complete
  // }

  // Render
  return (
    <div className="w-full h-full flex flex-col justify-between">
      <div>
        {secondActiveIndex !== null ? (
          <div
            className="text-white flex items-center p-5 gap-4 bg-brand"
            onClick={() => {
              setSecondLevelMenus([]);
              setSecondActiveIndex(null);
              setHighlightedMenu(null);
              setThirdActiveIndex(null);
            }}
          >
            <div>
              <BackArrow />
            </div>
            <div>{higjhlightedMenu}</div>
          </div>
        ) : (
          <div className="text-white flex items-center px-5 py-6 gap-2 min-w-max">
            {/* <button>
            <Avatar />
          </button> */}

            {userIsSigned ? (
              <>
                {userProfileImage ? (
                  <div className="w-10 h-10 rounded-full border flex items-center justify-center">
                    <img
                      src={userProfileImage}
                      alt="profile icon"
                      className="w-full h-full object-cover rounded-full"
                    />
                  </div>
                ) : (
                  <button
                    className="w-10 h-10 rounded-full hover:ring-2 border-2 hover:ring-brand flex items-center text-negative tracking-wide font-semibold bg-red_200 justify-center"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`${process.env.play_base_url}/dashboard`);
                    }}
                  >
                    {useInitials}
                  </button>
                )}
              </>
            ) : (
              <button
                className=" bg-surface_subtle hover:bg-surface_default rounded-full"
                onClick={() => navigate("/")}
              >
                <Avatar />
              </button>
            )}

            <div className="text-white text-body_lg font-semibold">
              My Account
            </div>
          </div>
        )}

        {secondActiveIndex !== null ? (
          <>
            {secondLevelMenus?.map((item, thirdIndex) => {
              const { id, label, url, children } = item;

              return (
                <div key={thirdIndex}>
                  <div  
                    className="text-white flex justify-between items-center p-5 active:text-telecel_gray cursor-pointer"
                    onClick={() => {
                      if (thirdActiveIndex === thirdIndex) {
                        //close menu when reclicked
                        setThirdActiveIndex(null);
                      } else {
                        setThirdActiveIndex(thirdIndex);
                      }
                    }}
                  >
                    <div className=" font-semibold text-body_base active:text-brand">
                      {label}
                    </div>

                    {!children.length ? null : (
                      <>
                        {children.length && thirdActiveIndex === thirdIndex ? (
                          <CaretUp />
                        ) : (
                          <CaretDown />
                        )}
                      </>
                    )}
                  </div>
                  {thirdActiveIndex === thirdIndex && (
                    <div className="border-b border-surface_dark">
                      {children?.map((item, index) => {
                        const { id, label, url } = item;
                        return (
                          <button 
                            key={index}
                            className="block w-full text-left p-5 bg-telecel_white border-b text-surface_dark font-semibold text-body_base  active:text-brand"
                            onClick={() => {
                              navigate(url);
                              // console.log("clicked", url);
                            }}
                          >
                            {label}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </>
        ) : (
          <>
            {menuItems.map((item, index) => {
              const { id, labels, url, menu } = item;
              
              //if active index is not null, display inner menu for current page level else display toggled inner menu
              const showInnerMenu = typeof activeIndex === "number" ?  (activeIndex === index) : (PageLevel === index);
              // console.log("activeIndex", activeIndex)
              // console.log("index", index)
              // console.log("PageLevel", PageLevel)
              // console.log("showInnerMenu", showInnerMenu)


              return (
                <div key={id}>
                  <div key={index}
                    className="flex justify-between items-center p-5 bg-brand border-y border-surface_dark"
                    onClick={() => {
                      // if (activeIndex === index) {
                      //   //close menu when reclicked
                      //   setActiveIndex(null);
                      // } else {
                      //   setActiveIndex(index);
                      // }
                      setActiveIndex(index);
                    }}
                  >
                    <div className="text-white font-semibold text-body_base">
                      {labels}
                    </div>
                    {!menu.length ? null : (
                      <>
                        {menu.length && activeIndex === index ? (
                          <CaretUp />
                        ) : (
                          <CaretDown />
                        )}
                      </>
                    )}
                  </div>

                  {showInnerMenu && (
                    <div className={`border-b border-surface_dark `}>
                      {menu?.map((item, secondIndex, array) => {
                        const { id, label, url, children } = item;
                        const isCurrentPage = findMobileSubMenuItems(array, urlPathName);
                          // console.log("isCurrentPage", isCurrentPage )
                        return (
                            <button 
                            key={secondIndex}
                              className="w-full flex justify-between items-center px-5 py-[10px] active:bg-telecel_gray"
                              onClick={() => {
                                if (!children.length) {
                                  // onToggle();
                                  navigate(url);
                                } else {
                                  if (typeof item.children === 'function') {
                                    const telecelPlayChildren =  item.children(userType).map(child => child); //telecelPlayChildren are of type functions because the userType determines the children of the menu
                                    setSecondLevelMenus(telecelPlayChildren);
                                  } else { 
                                    setSecondLevelMenus(children);
                                  }
                                  // setSecondLevelMenus(children);
                                  setSecondActiveIndex(secondIndex);
                                  setHighlightedMenu(`${labels}/${label}`);
                                }
                              }}
                            >


                              <div className={`py-[10px] text-white font-semibold text-body_base  ${isCurrentPage?.label === label ? 'border-b border-white' : ''}`}>
                                {label}
                              </div>

                              {!children.length ? null : (
                             <CaretRight />
                              )}
                            </button>
                        
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>

      {userIsSigned && (
        <button
          className="p-5 bg-negative text-body flex items-center justify-between font-semibold text-body_base"
          onClick={(e) => {
            e.preventDefault();
            handleUserLogout();
          }}
        >
          Logout <SignOut size={20} />
        </button>
      )}
    </div>
  );
}

// Export
export default FullMenu;
